"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMAIN_BENCHMARK = void 0;
/**
 * @public
 */
exports.DOMAIN_BENCHMARK = 'benchmark';
//# sourceMappingURL=benchmark.js.map